import  NaCodeMaintenanceApiURLs  from '../../../../apiUrls/NaCodeMaintenanceApiUrls'
import { CodeMaintenanceType } from 'src/constants/nacodemaintenance'
import { components} from 'cng-web-lib'
import PropTypes from 'prop-types'
import React from 'react'
import {getCodeDescriptionByUserLanguage, getCodeIntlCodeDescriptionByUserLanguage} from 'src/common/TranslationCommon'

const {
  card: {
    CngSimpleCardHeader,
  },
  form: {
    field: {
      CngTextField,
      CngLookupAutocompleteField
    },
  },
  CngGridItem,
} = components

/**
 *
 * @visibleName Code maintenance autocomplete
 */
function NaPortAutocompleteField(props, codeMaintenanceType,setIndicator) {

  const {
    lookupProps = {},
    ...lookupAutocompleteProps
  } = props
  const { filters = [], ...otherLookupProps } = lookupProps

  return (
    <CngLookupAutocompleteField
      {...lookupAutocompleteProps} 
      lookupProps={{
        url: NaCodeMaintenanceApiURLs.GET,
        customData: { codeMType: codeMaintenanceType },
        label: (record) => {
          const description = getCodeDescriptionByUserLanguage(record)
          if (props.portCode) {
            return  getCodeIntlCodeDescriptionByUserLanguage(record)
          }
          return description;
        },
        value: 'code',
        shouldEnableSessionCache: true,
        filters: [
          {
            field: 'active',
            operator: 'equal',
            value: true
          },
          {
            field: 'set_indicator',
            operator: 'equal',
            value: setIndicator
          },
          {
            field: 'intlcode',
            operator: 'equal',
            value: props.portCode
          },
          ...filters
        ],
        ...otherLookupProps
      }}
    />
  )
}

NaPortAutocompleteField.propTypes = {
  /** @ignore */
  codeMaintenanceType: PropTypes.oneOf(Object.values(CodeMaintenanceType))
    .isRequired,
  /** @ignore */
  lookupProps: PropTypes.object
}

export default NaPortAutocompleteField
